<section>
  <div class="make-a-claim-wrapper">
    <div
      *ngFor="
        let card of internationalStudentData.make_a_claim_cards;
        let i = index
      "
    >
      <app-make-a-claim-card
        [cardTitle]="processTitle(card.title, i)"
        [cardExcerpt]="card.excerpt ?? ''"
        [cardButton]="getCardButtonObject(card)"
        [cardClaimNumber]="card.make_a_claim_number ?? ''"
      ></app-make-a-claim-card>
    </div>
  </div>
</section>

<div
  class="need-help-background"
  [style.background-image]="
    'url(' + internationalStudentData.help_image_web?.data?.attributes?.url + ')'
  "
>
  <div class="need-help-banner-wrapper">
    <div class="need-help-banner">
      <div class="content">
        <h2>
          {{ internationalStudentData.need_help_title }}
        </h2>
        <p>{{ internationalStudentData.need_help_sub_title }}</p>
      </div>
      <button type="button" (click)="navigateToContactUs()">
        {{ internationalStudentData.need_help_link_text }}
        <img src="/assets/icons/primary_arrow_right.svg" alt="" />
      </button>
    </div>
  </div>
</div>
